import { Action } from 'redux'
import { RestModels } from 'tradehub-api-js'

export enum BlockActionType {
  CLEAR = 'CLEAR_BLOCK',
  SET_TRANSACTIONS = 'SET_BLOCK_TRANSACTIONS',
  SET_EVENTS = 'SET_BLOCK_EVENTS',
  SET_BLOCK_INFO = 'SET_BLOCK_INFO',
}

export type BlockAction =
  | ClearAction
  | SetTransactionsAction
  | SetEventsAction
  | SetBlockInfoAction

export interface ClearAction extends Action<BlockActionType.CLEAR> {}
export function clear(): ClearAction {
  return {
    type: BlockActionType.CLEAR,
  }
}

export interface SetTransactionsAction
  extends Action<BlockActionType.SET_TRANSACTIONS> {
  transactions: Array<RestModels.Txn>
}
export function setTransactions(
  transactions: Array<RestModels.Txn>,
): SetTransactionsAction {
  return {
    type: BlockActionType.SET_TRANSACTIONS,
    transactions,
  }
}

export interface SetEventsAction extends Action<BlockActionType.SET_EVENTS> {
  events: RestModels.BlockEvents
}
export function setEvents(events: RestModels.BlockEvents): SetEventsAction {
  return {
    type: BlockActionType.SET_EVENTS,
    events,
  }
}
export interface SetBlockInfoAction
  extends Action<BlockActionType.SET_BLOCK_INFO> {
  blockInfo: RestModels.CosmosBlock
}
export function setBlockInfo(blockInfo: RestModels.CosmosBlock): SetBlockInfoAction {
  return {
    type: BlockActionType.SET_BLOCK_INFO,
    blockInfo,
  }
}
